
<div  class="contractes-content">
  <div class="mdl-grid mdl-grid--no-spacing">
    <h5 class="mdl-layout-title mdl-cell--8-col">
      {{::ctrl.entitat.nom | translate}}
    </h5>
    <div class="mdl-cell mdl-cell--4-col">
      <div class="itec-float-right">
        <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"
            ng-if="$root.permisos.ESBORRARENT.delete"
            itec-dialog-confirm
            itec-dialog-confirm-title="DEFAULT_TITOL_CONFIRMACIO_ESBORRAR"
            itec-dialog-confirm-text-content="ENTITAT_DELETE_CONTENT"
            itec-dialog-confirm-text-ok="DIALOG_CONFIRM"
            itec-dialog-confirm-text-cancel="DIALOG_CANCEL"
            itec-dialog-confirm-function-ok="ctrl.deleteElem()">
          <i class="material-icons">delete</i>
        </button>
        <button
            class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"
            ng-if="$root.permisos.ACTUALITZARENT.edit"
            ng-click="ctrl.edit()">
          <i class="material-icons">edit</i>
        </button>
      </div>
    </div>
    <div class="mdl-cell--12-col">
      <md-card>
        <md-card-content>
          <div class="mdl-grid mdl-grid--no-spacing">
            <div class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_NOM' | translate}}:</span>
            </div>
            <div class="mdl-cell mdl-cell--4-col">
              <span class="bold">{{::ctrl.entitat.nom}}</span>
            </div>
            <div class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_NIF' | translate}}:</span>
            </div>
            <div class="mdl-cell mdl-cell--4-col">
              <span class="bold">{{::ctrl.entitat.nif}}</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_CODI' | translate}}:</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">
              <span class="bold">{{::ctrl.entitat.codi}}</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_CODI_client' | translate}}:</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">
              <span class="bold">{{::ctrl.entitat.codiclient}}</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_TYK_PROPI' | translate}}:</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">
              <span  ng-if="ctrl.entitat.tetykpropi==true" class="bold">{{'DEFAULT_SI' | translate}}</span>
              <span  ng-if="ctrl.entitat.tetykpropi==false" class="bold">{{'DEFAULT_NO' | translate}}</span>
            </div>
             <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_BLOQUEJADA' | translate}}:</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">
              <span  ng-if="ctrl.entitat.bloquejada==true" class="bold">{{'DEFAULT_SI' | translate}}</span>
              <span  ng-if="ctrl.entitat.bloquejada==false" class="bold">{{'DEFAULT_NO' | translate}}</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">
              <span>{{::'DEFAULT_TIPUS' | translate}}:</span>
            </div>
            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">
              <span  class="bold">{{ ctrl.entitat.tipus_client | translate}}</span>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
  <div class="tcqi--margin-bottom-20" ng-if="$root.issuperadmin">
  <form name="form" class="mdl-grid mdl-grid--no-spacing">
    <div class="mdl-cell mdl-cell--6-col" ng-if="$root.permisos.LOGIN.add">
      <itec-form-file-upload
      name="form"
      class="mdl-cell mdl-cell--12-col"
      files="ctrl.files"
      err-files="ctrl.errFiles"
      funcio-seleccionar="ctrl.uploadFile()"
      select-files-text="{{'IMPORTAR_USUARIS_EXCEL' | translate}}"
      max-size="{{vm.maxSize}}"
      pattern="['.xlsx', '.xls' ,'.ods']"
      show-only-icon="false"
      icon-left="ctrl.iconLeft"
      parent-ctrl="ctrl"
      multiple-files="false"
      show-header="ctrl.showHeader"
      close-after-doc-selection="true"
      title="{{ctrl.title}}">

    </itec-form-file-upload>
    </div>
    <div class="mdl-cell mdl-cell--9-col" ng-show="ctrl.fitxercarrega.fields.selected || ctrl.fitxercarrega.status == 'done'">
      {{vm.fitxercarrega.file.name}}
      <md-button ng-show="ctrl.fixercarrega.file.progress==100" class="md-icon-button">
        <md-icon>done</md-icon>
      </md-button>
      <span flex></span>
      <md-progress-linear md-mode="determinate" value="{{ctrl.fitxercarrega.file.progress}}">
      </md-progress-linear>
    </div>
  </form>

  <itec-form-file-upload-errors
    err-files="ctrl.errFiles"
    max-size="{{ctrl.maxSize}}"
    max-size-exceeded-text={{maxSizeExceededText}}>
  </itec-form-file-upload-errors>

</div>

</div>
